import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import api from '../api';
import './FooterPages.css';

const ContactUs = () => {
    const [toasts, setToasts] = useState([]);
    const showToast = (message, type = 'success') => {
        const id = Date.now();
        setToasts(prev => [...prev, { id, message, type }]);
        setTimeout(() => {
            setToasts(prev => prev.filter(toast => toast.id !== id));
        }, 4000);
    };
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await api.post('/contact/', formData);
            showToast('Message sent successfully! We will get back to you shortly.');
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            console.error('Error sending message:', error);
            if (error.response) {
                showToast('Failed to send message. Please try again.', 'error');
            } else {
                showToast('Network error. Please try again later.', 'error');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="footer-page-container">
            <div className="footer-page-inner">

                {/* Toast Notification */}
                <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 1000, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {toasts.map(toast => (
                        <div key={toast.id} style={{
                            padding: '12px 24px',
                            background: toast.type === 'error' ? 'rgba(239, 68, 68, 0.9)' : 'rgba(16, 185, 129, 0.9)',
                            color: 'white',
                            borderRadius: '8px',
                            backdropFilter: 'blur(8px)',
                            border: '1px solid rgba(255,255,255,0.2)',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            animation: 'slideIn 0.3s ease-out'
                        }}>
                            {toast.message}
                        </div>
                    ))}
                </div>

                <Link to="/" className="footer-back-btn">
                    <FaArrowLeft /> Back to Home
                </Link>

                <div className="footer-header">
                    <h1 className="footer-title">Get in Touch</h1>
                    <p className="footer-subtitle">
                        Have questions about the platform? Interested in partnering with us? We'd love to hear from you.
                    </p>
                </div>

                <div className="footer-contact-grid">
                    <div className="footer-text-section" style={{ margin: 0 }}>
                        <h3 style={{ color: '#f8fafc', marginBottom: '0.5rem', fontSize: '1.5rem' }}>Email Us</h3>
                        <p style={{ color: '#818cf8', marginBottom: '0.5rem' }}>support@edvergencex.com</p>

                        <h3 style={{ color: '#f8fafc', marginBottom: '0.5rem', fontSize: '1.5rem' }}>Visit Us</h3>
                        <p style={{ color: 'var(--text-muted)', lineHeight: '1.6' }}>No. 67, 3rd Main,<br />R.M.V. Extension II Stage, Bangalore North,<br />Karnataka – 560094</p>
                    </div>

                    <div className="footer-glass-card" style={{ transform: 'none' }}>
                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: '1.5rem' }}>
                                <label style={{ display: 'block', color: 'var(--text-muted)', marginBottom: '0.5rem', fontWeight: '600' }}>Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid rgba(71, 85, 105, 0.5)', background: 'rgba(15, 23, 42, 0.6)', color: '#f8fafc', outline: 'none', transition: 'border-color 0.3s' }}
                                    onFocus={(e) => e.target.style.borderColor = '#818cf8'}
                                    onBlur={(e) => e.target.style.borderColor = 'rgba(71, 85, 105, 0.5)'}
                                />
                            </div>
                            <div style={{ marginBottom: '1.5rem' }}>
                                <label style={{ display: 'block', color: 'var(--text-muted)', marginBottom: '0.5rem', fontWeight: '600' }}>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid rgba(71, 85, 105, 0.5)', background: 'rgba(15, 23, 42, 0.6)', color: '#f8fafc', outline: 'none', transition: 'border-color 0.3s' }}
                                    onFocus={(e) => e.target.style.borderColor = '#818cf8'}
                                    onBlur={(e) => e.target.style.borderColor = 'rgba(71, 85, 105, 0.5)'}
                                />
                            </div>
                            <div style={{ marginBottom: '1.5rem' }}>
                                <label style={{ display: 'block', color: 'var(--text-muted)', marginBottom: '0.5rem', fontWeight: '600' }}>Subject</label>
                                <input
                                    type="text"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid rgba(71, 85, 105, 0.5)', background: 'rgba(15, 23, 42, 0.6)', color: '#f8fafc', outline: 'none', transition: 'border-color 0.3s' }}
                                    onFocus={(e) => e.target.style.borderColor = '#818cf8'}
                                    onBlur={(e) => e.target.style.borderColor = 'rgba(71, 85, 105, 0.5)'}
                                />
                            </div>
                            <div style={{ marginBottom: '2rem' }}>
                                <label style={{ display: 'block', color: 'var(--text-muted)', marginBottom: '0.5rem', fontWeight: '600' }}>Message</label>
                                <textarea
                                    name="message"
                                    rows="5"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid rgba(71, 85, 105, 0.5)', background: 'rgba(15, 23, 42, 0.6)', color: '#f8fafc', resize: 'vertical', outline: 'none', transition: 'border-color 0.3s' }}
                                    onFocus={(e) => e.target.style.borderColor = '#818cf8'}
                                    onBlur={(e) => e.target.style.borderColor = 'rgba(71, 85, 105, 0.5)'}
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="footer-cta-btn"
                                style={{
                                    width: '100%',
                                    marginTop: 0,
                                    opacity: isSubmitting ? 0.7 : 1,
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {isSubmitting ? 'Sending...' : 'Send Message'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <style>
                {`
                @keyframes slideIn {
                    from { transform: translateX(100%); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
                `}
            </style>
        </div>
    );
};

export default ContactUs;


